// extracted by mini-css-extract-plugin
module.exports = {"root":"InsertAnswerButton_root__r-kEy","button":"InsertAnswerButton_button__2bT51","button__isAbove":"InsertAnswerButton_button__isAbove__170wt"};